import { ApplicationRef, ComponentRef, Directive, ElementRef, EmbeddedViewRef, HostListener, ViewContainerRef, input } from "@angular/core";
import {BPSpreadTooltipComponent} from "./bp-spread-tooltip.component";
import { BPSpreadData } from "../../models/auction";

@Directive({standalone: false,
  selector: '[bpSpreadTooltip]'
})
export class BPSpreadTooltipDirective {

  readonly bpSpreadTooltip = input.required<BPSpreadData>();

  private componentRef?: ComponentRef<any>;

  constructor(private elementRef: ElementRef,	private appRef: ApplicationRef, private viewContainerRef: ViewContainerRef) {
  }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    if (!this.componentRef) {
        this.componentRef = this.viewContainerRef.createComponent(BPSpreadTooltipComponent);
        this.setTooltipComponentProperties();  
        //this.appRef.attachView(this.componentRef.hostView);
        const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
        domElem.addEventListener('mouseleave', () => {
          this.destroy();
        });
        document.body.appendChild(domElem);
    }
  }

  /*
  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.destroy();
  }
  */

  private setTooltipComponentProperties() {
    if (this.componentRef) {
      this.componentRef.instance.bpSpreadData = this.bpSpreadTooltip();
      const {left, right, bottom} = this.elementRef.nativeElement.getBoundingClientRect();
      this.componentRef.instance.left = left;
      this.componentRef.instance.top = bottom+10;
    }
  }


  ngOnDestroy(): void {
    this.destroy();
  }

  destroy(): void {
    if (this.componentRef) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
      this.componentRef = undefined;
    }
  }
}